import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";

const changedField = 'changed__time';

export default {
    state: {
        idlings_index: [],
        idlings: [],
        idlings_last_hour: [],
    },
    actions: {
        fetchIdlings4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getIdlingsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchIdlings4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('idlings', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.idlings.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeIdlings', response.data)
                            commit('setIdlingsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                //dispatch('fetchIdlingsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                response.data
                                    .map(e => e.unit_id)
                                    .filter(arrayFilter_OnlyUnique)
                                    .forEach(unitId => {
                                        commit('setIdlingsIndex', {...args, unitId, count: 1})
                                    })
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchIdlings4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchIdlings4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getIdlingsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchIdlings4Date', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchIdlings4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('idlings', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;delete params.force;
                this.$api.idlings.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeIdlings', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchIdlings4Date', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchIdlings4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchIdlingsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastIdlings', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchIdlings4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastIdlings', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchIdlingsChanged', args, inprogress: false})
                });
        },

        fetchIdlingsLastTime({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }
                let lmsg_time = getters.getUnitsLmsgsByIds[args.unitId]?.time || 0
                if (!(lmsg_time > getters.getTimeToday)) {
                    return resolve(true)
                }
                let today = getters.getDateToday
                //Index today
                let indx_today = getters.getIdlingsIndex.find(i => i.date == today && i.unitId == args.unitId)
                if (!indx_today) {
                    return resolve(true)
                }
                //trips&parkings time_end
                let time_ends = [
                    getters.getTripsMaxTimeEndByUnitsIds[args.unitId],
                    getters.getParkingsMaxTimeEndByUnitsIds[args.unitId]
                ].filter(t => !!t && t > 0)
                if (!time_ends.length) time_ends = [getters.getTimeToday]
                let time_start = Math.max(...time_ends)

                if (time_start > lmsg_time) {
                    console.warn('fetchIdlingsLastTime: Lmsg.time', {args, lmsg_time, time_start})
                    return resolve(true)
                }

                dispatch('setLastCall', {name: 'fetchIdlingsLastTime', args, time: Date.now() / 1000})

                let params = getApiProps('idlings', {withAddress: 1, ...args, date: '', 'start-time': time_start})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.idlings.getLast(args.unitId, '', params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeIdlingsLastHour', {unitId: args.unitId, time_start, data: response.data})
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchIdlingsLastTime', args, inprogress: false})
                    });
            })
        },

        reloadIdlings({commit, dispatch}, args) {
            commit('clearIdlings')
            return dispatch('fetchIdlings4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setIdlingsIndex(state, params) {
            let i = state.idlings_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.idlings_index.push(Object.freeze({...params}))
            } else {
                state.idlings_index[i] = Object.freeze({...state.idlings_index[i], ...params})
            }
        },
        storeIdlings(state, nIdlings) {
            const exactKeys = new Set(state.idlings.map(i => `${i.unit_id}|${i.time_start?.utc}|${i.time_end?.utc}`))
            nIdlings = nIdlings
                .filter(i => !exactKeys.has(`${i.unit_id}|${i.time_start?.utc}|${i.time_end?.utc}`))
                //.map(i => Object.freeze(i))

            // if(nIdlings.length) state.idlings.push(...nIdlings)
            if (!nIdlings.length) return false
            if (!state.idlings.length) {
                state.idlings = nIdlings
                return true
            }
            const indexByIdentity = new Map(state.idlings.map((st, i) => [`${st.unit_id}|${st.time_start?.utc}`, i]))
            nIdlings.forEach(function (nIdling) {
                const identityKey = `${nIdling.unit_id}|${nIdling.time_start?.utc}`
                let i = indexByIdentity.has(identityKey) ? indexByIdentity.get(identityKey) : -1
                if (i < 0) {
                    indexByIdentity.set(identityKey, state.idlings.length)
                    state.idlings.push(Object.freeze(nIdling))
                } else
                if (state.idlings[i][changedField] != nIdling[changedField])
                {
                    // updateObjectByDiff(state.idlings[i], nIdling)
                    delete nIdling.unit_id;delete nIdling.time_start;
                    state.idlings[i] = Object.freeze({...state.idlings[i], ...nIdling})
                }
            })
        },

        storeIdlingsLastHour(state, args) {
            state.idlings_last_hour = state.idlings_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nIdlings = args.data
            nIdlings = nIdlings
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.idlings_last_hour.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
            //.map(t => Object.freeze(t))

            // if(nIdlings.length) state.idlings_last_hour.push(...nIdlings)
            if (!nIdlings.length) return false
            if (!state.idlings_last_hour.length) {
                state.idlings_last_hour = nIdlings
                return true
            }
            nIdlings.forEach(function (nIdling) {
                let i = state.idlings_last_hour.findIndex(st => {
                    return st.unit_id == nIdling.unit_id
                        && st.time_start?.utc == nIdling.time_start?.utc
                    // && st.time_end?.utc == nIdling.time_end?.utc
                })
                if (i < 0) {
                    state.idlings_last_hour.push(nIdling) //(Object.freeze(nIdling))
                } else
                {
                    updateObjectByDiff(state.idlings_last_hour[i], nIdling)
                    // nIdling = {...state.idlings_last_hour[i], ...nIdling}
                    // state.idlings_last_hour[i] = nIdling //Object.freeze(nIdling)
                }
            })
        },

        clearIdlings(state, {unitId} = {}) {
            if (unitId) {
                state.idlings_last_hour = state.idlings_last_hour.filter(i => (i.unit_id || i.object_id) != unitId)
                state.idlings = state.idlings.filter(i => (i.unit_id || i.object_id) != unitId)
                state.idlings_index = state.idlings_index.filter(i => i.unitId != unitId)
            } else {
                state.idlings_last_hour = [];
                state.idlings = [];
                state.idlings_index = [];
            }
        },
    },
    getters: {
        getIdlingsIndex(state) {
            return state.idlings_index
        },
        getIdlings(state) {
            return [...state.idlings, ...state.idlings_last_hour]
        },
    }
}
